import React, { useEffect, useState } from 'react';
import HeaderSCI from './HeaderSCI';
import './controlinterno.css';

const principios = [
  {
    id: 13,
    color: '#621132',
    title: "Principio 13. - Usar Información de Calidad.",
    items: [
       // { label: "Programa de Trabajo de Administración de Riesgos (PTAR).", url: "/micro/principio7/PTAR 2026 PRESENTAR.pdf" },
      // "Características y Fuentes Confiables de Obtención de Datos.",
      // "Guia para la Integración y Rendición de los Informes de Gestión Financiera y Cuenta Pública para el Ejercicio Fiscal",
      // "Portal de Transparencia o Unidad de Transparencia"
    ]
  },
  {
    id: 14,
    color: '#9e2348',
    title: "Principio 14. - Comunicar Internamente.",
    items: [
       // { label: "Programa de Trabajo de Administración de Riesgos (PTAR).", url: "/micro/principio7/PTAR 2026 PRESENTAR.pdf" },
      // "Portal de Internet",
      // "Medios formales de Comunicación interna"
    ]
  },
  {
    id: 15,
    color: '#a98188',
    title: "Principio 15. - Comunicar Externamente.",
    items: [
       // { label: "Programa de Trabajo de Administración de Riesgos (PTAR).", url: "/micro/principio7/PTAR 2026 PRESENTAR.pdf" },
      // "Buzón de Denuncias",
      // "Portal de Internet",
      // "Medios formales de comunicación externa o Lineamientos de Comunicación Interna y/o Externa"
    ]
  }
];

const InformacionComunicacion = () => {
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const toggleAccordion = (id) => {
    setExpandedId(prev => (prev === id ? null : id));
  };

  return (
    <>
      <HeaderSCI title="COMPONENTES DEL CONTROL INTERNO" />

      <div className="container ci-nav pt-4">
        {/* Title pill */}
        <div className="row justify-content-center mb-4">
          <div className="col-12 col-md-5 d-flex justify-content-center">
            <div className="ci-nav__btn--pill" style={{ cursor: 'default', margin: 0 }}>
              Información y Comunicación
            </div>
          </div>
        </div>

        {/* Text Description */}
        <div className="row justify-content-center mb-5">
          <div className="col-12 col-md-10">
            <p className="ci-desc-text">
              Es la información de calidad que la Administración y los demás servidores públicos generan, obtienen, utilizan y comunican para respaldar el sistema de Control Interno y dar cumplimiento a su mandato legal.
            </p>
          </div>
        </div>

        {/* Accordion / Toggle List */}
        <div className="row justify-content-center">
          <div className="col-12 col-md-10">
            {principios.map((prin) => {


              const isExpanded = expandedId === prin.id;

              return (
                <div key={prin.id} className="mb-2">
                  {/* Header Button */}
                  <div 
                    className="ci-nav__btn ci-nav__btn--doc" 
                    onClick={() => toggleAccordion(prin.id)}
                    style={{ cursor: 'pointer', padding: '8px 12px' }}
                  >
                    <div className="ci-nav__icon" style={{ backgroundColor: prin.color }}>
                      <i className="fa-solid fa-id-card"></i>
                    </div>
                    <span className="ci-nav__label ci-nav__label--doc" style={{ fontSize: '1rem', color: '#621132' }}>
                      {prin.title}
                    </span>
                  </div>

                  {/* Expanded Content */}
                  <div className={`ci-accordion-wrapper ${isExpanded ? 'is-open' : ''}`}>
                    <div className="ci-accordion-inner">
                      {prin.items.length > 0 ? (
                        <div className="ci-accordion-content ps-5 mt-1 mb-2">
                          <ul style={{ color: prin.color, fontSize: '0.95rem', fontStyle: 'italic', lineHeight: '1.6' }}>
                            {prin.items.map((item, idx) => (
                              <li key={idx} className="mb-2">
                                <a href="#" style={{ color: '#621132' }}>{item}</a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        <div className="ci-accordion-content ps-5 mt-1 mb-2">
                          <p style={{ color: '#621132', fontSize: '0.95rem', fontStyle: 'italic' }}>
                            No hay documentos disponibles.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default InformacionComunicacion;
